module.exports = __webpack_public_path__ + "media/images/smart_phone/products/udon-c48eba8ac2a77eb68df057b3e04f1246.jpeg";